import common from './common'

const primary = {
  ...common.button,
  color: `white`,
  bg: `alpha`,
  borderColor: `alpha`,
  borderWidth: `md`,
  borderStyle: `solid`,
  ':hover': {
    color: `omegaLighter`,
    bg: `omegaDark`,
    borderColor: `omegaDark`
  }
}

export default primary